import { createFileRoute } from '@tanstack/react-router'

import { useBotCreationStore } from '../../../stores'
import { BpSpinner } from '../../../elements'
import { useRef } from 'react'
import { useAsync } from 'react-use'
import { showBotTypeSelectionDialog } from '../../../features/bots/components/BotTypeSelectionDialog'
import { useFeature } from '~/hooks/useFeature'
import { config } from '~/shared'
import { setWorkspacePreference } from '~/services/preferences/workspacePreferences'

export const Route = createFileRoute('/workspaces/$workspaceId/create-bot')({
  component: RouteComponent,
})

function RouteComponent() {
  const { workspaceId } = Route.useParams()
  const createBot = useBotCreationStore((state) => state.createBot)
  const createAdkBot = useBotCreationStore((state) => state.createAdkBot)
  const navigate = Route.useNavigate()
  const isOnboardingEnabled = useFeature('dashboard-onboarding')

  const hasRunRef = useRef(false)

  useAsync(async () => {
    if (hasRunRef.current) return
    hasRunRef.current = true

    const botType = await showBotTypeSelectionDialog({ dismissable: false })

    if (botType === 'adk') {
      createAdkBot({
        workspaceId,
        name: 'New Agent',
        onBotCreated: (newBot) =>
          navigate({
            to: '/workspaces/$workspaceId/bots/$botId/new-adk-bot-setup',
            from: '/workspaces/$workspaceId',
            params: { botId: newBot.id },
          }),
      })
    } else {
      // Default to Studio if dismissed or selected
      createBot({
        workspaceId,
        onBotCreated: async (newBot) => {
          if (isOnboardingEnabled) {
            navigate({
              to: '/workspaces/$workspaceId/bots/$botId/new-bot',
              from: '/workspaces/$workspaceId',
              params: { botId: newBot.id },
            })
          } else {
            await setWorkspacePreference(
              { path: 'isStudioOnboarding/$botId', params: { botId: newBot.id }, value: true },
              workspaceId
            )
            window.location.href = `${config.studioBaseUrl}/${newBot.id}`
          }
        },
      })
    }
  }, [])

  return (
    <div className="flex h-[80vh] w-full items-center justify-center">
      <BpSpinner className="h-20 w-20" />
    </div>
  )
}
